
 



 
 import {fs} from "Config/FsConfig";
 
    import DashboardSearchParameter from 'Modules/Aqs/Scripts/AppServiceContract/DashboardSearchParameter';

    import AirQualityGroupData from 'Modules/Aqs/Scripts/AppServiceContract/AirQualityGroupData';

    import AirQualityGraphData from 'Modules/Aqs/Scripts/AppServiceContract/AirQualityGraphData';

    import DashboardSearchCriteria from 'Modules/Aqs/Scripts/AppServiceContract/DashboardSearchCriteria';

    import DistrictGroupData from 'Modules/Aqs/Scripts/AppServiceContract/DistrictGroupData';

    import StationParameter from 'Modules/Aqs/Scripts/AppServiceContract/StationParameter';

    import DistrictData from 'Modules/Aqs/Scripts/AppServiceContract/DistrictData';

    import DistrictParameter from 'Modules/Aqs/Scripts/AppServiceContract/DistrictParameter';

    import StationData from 'Modules/Aqs/Scripts/AppServiceContract/StationData';

    import AirQualityTypeData from 'Modules/Aqs/Scripts/AppServiceContract/AirQualityTypeData';

    import SummaryDataHeader from 'Modules/Aqs/Scripts/AppServiceContract/SummaryDataHeader';

    import LocationRequest from 'Modules/Aqs/Scripts/AppServiceContract/LocationRequest';


    //module DashboardAppService {
    class DashboardAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Aqs.AppService/DashboardAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Aqs.AppService/DashboardAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/
    //public static RouteFindTable = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/DashboardAppService/FindTable`;
    public RouteFindTable() : string {
        return this.ControllerUrl + "/"+"FindTable";
    }
    public FindTable(parameter: DashboardSearchParameter): JQuery.jqXHR<AirQualityGroupData[]> {
        return $.ajax({
                url: this.RouteFindTable(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(parameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindGraph = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/DashboardAppService/FindGraph`;
    public RouteFindGraph() : string {
        return this.ControllerUrl + "/"+"FindGraph";
    }
    public FindGraph(parameter: DashboardSearchParameter): JQuery.jqXHR<AirQualityGraphData[]> {
        return $.ajax({
                url: this.RouteFindGraph(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(parameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteCount = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/DashboardAppService/Count`;
    public RouteCount() : string {
        return this.ControllerUrl + "/"+"Count";
    }
    public Count(criteria: DashboardSearchCriteria): JQuery.jqXHR<number> {
        return $.ajax({
                url: this.RouteCount(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(criteria),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteDistrictGroupDropdown = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/DashboardAppService/DistrictGroupDropdown`;
    public RouteDistrictGroupDropdown() : string {
        return this.ControllerUrl + "/"+"DistrictGroupDropdown";
    }
    public DistrictGroupDropdown(): JQuery.jqXHR<DistrictGroupData[]> {
        return $.ajax({
                url: this.RouteDistrictGroupDropdown(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteDistrictDropdown = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/DashboardAppService/DistrictDropdown`;
    public RouteDistrictDropdown() : string {
        return this.ControllerUrl + "/"+"DistrictDropdown";
    }
    public DistrictDropdown(parameter: StationParameter): JQuery.jqXHR<DistrictData[]> {
        return $.ajax({
                url: this.RouteDistrictDropdown(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(parameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteDistrictDropdown2 = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/DashboardAppService/DistrictDropdown2`;
    public RouteDistrictDropdown2() : string {
        return this.ControllerUrl + "/"+"DistrictDropdown2";
    }
    public DistrictDropdown2(parameter: DistrictParameter): JQuery.jqXHR<DistrictData[]> {
        return $.ajax({
                url: this.RouteDistrictDropdown2(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(parameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteStationDropdown = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/DashboardAppService/StationDropdown`;
    public RouteStationDropdown() : string {
        return this.ControllerUrl + "/"+"StationDropdown";
    }
    public StationDropdown(parameter: StationParameter): JQuery.jqXHR<StationData[]> {
        return $.ajax({
                url: this.RouteStationDropdown(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(parameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteAirQualityTypeList = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/DashboardAppService/AirQualityTypeList`;
    public RouteAirQualityTypeList() : string {
        return this.ControllerUrl + "/"+"AirQualityTypeList";
    }
    public AirQualityTypeList(): JQuery.jqXHR<AirQualityTypeData[]> {
        return $.ajax({
                url: this.RouteAirQualityTypeList(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindSummaryWeb = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/DashboardAppService/FindSummaryWeb`;
    public RouteFindSummaryWeb() : string {
        return this.ControllerUrl + "/"+"FindSummaryWeb";
    }
    public FindSummaryWeb(parameter: DashboardSearchParameter): JQuery.jqXHR<SummaryDataHeader[]> {
        return $.ajax({
                url: this.RouteFindSummaryWeb(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(parameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindDefaultStation = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/DashboardAppService/FindDefaultStation`;
    public RouteFindDefaultStation() : string {
        return this.ControllerUrl + "/"+"FindDefaultStation";
    }
    public FindDefaultStation(locationRequest: LocationRequest): JQuery.jqXHR<StationData> {
        return $.ajax({
                url: this.RouteFindDefaultStation(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(locationRequest),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default DashboardAppService;



